import { StyleProps } from '@chakra-ui/react';

export const wrapperStyle: StyleProps = {
  w: '100%',
  pt: 300,
  alignItems: { base: 'center', tablet: 'flex-start' },
};
export const countrycodeWrapperStyle: StyleProps = {
  py: 300,
  px: 400,
  alignItems: 'center',
  borderRadius: '4px',
  mr: 200,
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'neutral.300',
};
export const phoneNumErrorStyle: StyleProps = {
  color: 'danger.300',
  maxW: '188px',
  alignSelf: 'center',
};

export const successWrapperStyle: StyleProps = {
  bg: 'primary.100',
  py: 200,
  pl: 400,
  pr: 300,
  d: 'flex',
  borderRadius: '4px',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'neutral.300',
  alignItems: 'center',
};
